import { ValidationMessage_default } from "./chunk-ESL73LRM.js";
import { TransitionComponent } from "./chunk-3HAR27K6.js";
import { Link_default } from "./chunk-EFRJ3CR6.js";
import { Icon_default } from "./chunk-BTGG6N6L.js";
import { use_dismiss_default } from "./chunk-N3FBH5EY.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Notification/Notification.tsx
import React, { forwardRef, Fragment } from "react";
import clsx from "clsx";
var DEFAULT_COMPONENT = "div";
var NOTIFICATION_CLASSNAME_MAP = {
  variant: {
    primary: "pd-bg-primary-500 pd-bg-cover pd-bg-center pd-text-white [text-shadow:0.05rem_0.05rem_0.1rem_hsla(0,0%,0%,0.2)]",
    error: "pd-bg-error-100",
    info: "pd-bg-info-100",
    dim: "pd-bg-dim-100",
    success: "pd-bg-success-100",
    warning: "pd-bg-warning-100"
  }
};
var Notification = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant = "primary",
      isDismissible = false,
      dismissLabel,
      autoDismiss,
      onDismiss,
      role = "status",
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "isDismissible", "dismissLabel", "autoDismiss", "onDismiss", "role", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    isDismissed,
    handleDismiss
  } = use_dismiss_default(autoDismiss, onDismiss);
  return /* @__PURE__ */React.createElement(TransitionComponent, {
    as: Fragment,
    show: !isDismissed,
    variant: "appear-from-top"
  }, /* @__PURE__ */React.createElement(ValidationMessage_default, __spreadValues({
    ref,
    as: Component,
    variant: variant === "primary" ? void 0 : variant,
    className: clsx("pd-notification", isDismissible && "pd-px-12", NOTIFICATION_CLASSNAME_MAP.variant[variant], className),
    role
  }, rest), /* @__PURE__ */React.createElement("div", {
    className: "pd-flex-1"
  }, children), isDismissible &&
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  /* @__PURE__ */
  React.createElement(Link_default, {
    as: "button",
    type: "button",
    variant: "inherit",
    className: "pd-absolute pd-right-3 pd-top-3",
    onClick: handleDismiss
  }, /* @__PURE__ */React.createElement("span", {
    className: "pd-sr-only"
  }, dismissLabel), /* @__PURE__ */React.createElement(Icon_default, {
    icon: "times"
  }))));
});
var StoryNotification = args => /* @__PURE__ */React.createElement(Notification, __spreadValues({}, args));
var Notification_default = Notification;
export { NOTIFICATION_CLASSNAME_MAP, StoryNotification, Notification_default };